// Root route layout. Renders an <Outlet> for child routes.
//
// The app shell deliberately does NOT live here. Five auth routes, /no-access
// and every reading/review surface are chrome-free, so a shell mounted at the
// root would have to be conditionally suppressed on more routes than it wraps.
// It lives one level down instead, on the pathless layout route
// `routes/_shell.tsx`, which the seventeen shell-bearing screens are children
// of (PRD 18 US-152).

import { Outlet, createRootRoute } from "@tanstack/react-router";

export const rootRoute = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return <Outlet />;
}
